<app-header [historyBackAction]="historyBackAction" [title]="(isGlobalSearchView() ? 'SEARCH.GLOBAL_TITLE' : 'SEARCH.TITLE') | translate" class="search-overview-header" qaTag="search-overlay">
    @if (isGlobalSearchView()) {
        <app-icon [svgIcon]="ICONS.SEARCH_OVERALL"/>
    } @else {
        <app-icon [svgIcon]="ICONS.FIND_SELECTED|darkModeEnabled:ICONS.FIND_UNSELECTED"/>
    }
</app-header>

<app-search-dashboard [isFocusInputDisabled]="false" [isGlobalSearchView]="isGlobalSearchView()" [vaultId]="vaultId()"/>
